import { Card } from "@/components/ui//card";
import { cn } from "@/lib/utils";
import { Link, useLocation } from "react-router";

const valueContainedInLastPath = (pathname: string, value: string) => {
    const lastPath = pathname.split("?")[0].split("/").pop();
    return lastPath === value;
};

const LayoutTabHeader = () => {
    const location = useLocation();
    return (
        <div>
            <Card className="flex-1 border bg-gray-200 shadow-none">
                <div className="flex w-full  max-w-[calc(100vw-70px)] gap-3 overflow-x-auto p-1  md:overflow-x-hidden">
                    <Link
                        to="members"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "members") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Members
                    </Link>
                    <Link
                        to="permission-manage"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "permission-manage") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Manage Permissions
                    </Link>
                    <Link
                        to="subscriptions"
                        className={cn(
                            valueContainedInLastPath(location.pathname, "subscriptions") && "bg-white shadow-md border",
                            "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                        )}
                    >
                        Subscriptions
                    </Link>
                </div>
            </Card>
        </div>
    );
};

export default LayoutTabHeader;
